export const PAYA_CYCLES_TITLE = 'چه زمانی بعد از برداشت، به حسابم واریز می‌شود؟';

export const PAYA_CYCLES_DESCRIPTIONS = [
    'برداشت شما از طریق سامانه پایا در بازه‌های زمانی مشخصی بررسی می‌شود. این بازه‌ها که به آن‌ها «سیکل‌های پایا» گفته می‌شود، زمان‌هایی هستند که بانک‌ها تراکنش‌ها را به صورت گروهی پردازش می‌کنند. پس از بررسی در نزدیک‌ترین سیکل، مبلغ درخواستی به حساب بانکی شما واریز خواهد شد.',
    'می‌توانید زمان حدودی واریز مبلغ به حساب بانکی خود را از جدول زیر محاسبه کنید:',
];

export interface PayaCycle {
    requestTime: string;
    depositTime: string;
    hint?: string;
}

export const PAYA_CYCLES: PayaCycle[] = [
    { requestTime: '۳:۱۵ الی ۷:۴۵', depositTime: '۱۰:۰۰ الی ۱۱:۳۰' },
    { requestTime: '۷:۴۵ الی ۱۲:۰۰', depositTime: '۱۳:۳۰ الی ۱۴:۴۵' },
    { requestTime: '۱۲:۰۰ الی ۱۸:۰۰', depositTime: '۱۹:۳۰ الی ۲۰:۳۰' },
    { requestTime: '۱۸:۰۰ الی ۲۴:۰۰', depositTime: '۳:۳۰ الی ۴:۴۵', hint: 'بامداد روز بعد' },
];

export const PAYA_CYCLES_NOTE =
    'در روزهای جمعه و تعطیلات رسمی، پایا تنها در یک سیکل و در ساعت ۱۲:۴۵ انجام می‌شود. درخواست‌هایی که پس از این زمان ثبت شوند، در اولین سیکل روز بعد پردازش خواهند شد.';
